/*
French typography requires spaces around colons (' : ') for proper formatting https://en.wikipedia.org/wiki/French_orthography#Punctuation
This function would return appropriate separator based on locale so the end result will look like:

English: "Name: Value"
French: "Name : Value"
*/

export const getLocaleSeparator = (locale?: string) => {
  if (locale?.startsWith('fr')) {
    return ' : '
  }
  return ': '
}
